import { useState, useEffect, useContext } from "react";
import { DateTime } from "luxon";
import Proptypes from "prop-types";
import StoreContext from "../context/StoreContext";

const MessageTimer = ({ futureTime }) => {

  const { time_zone } = useContext(StoreContext);

  const calculateTimeLeft = () => {
    const now = DateTime.now().toUTC().setZone(time_zone);
    const diff = futureTime.diff(now, ["minutes", "seconds"]).toObject();

    return {
      minutes: Math.max(0, Math.floor(diff.minutes || 0)),
      seconds: Math.max(0, Math.floor(diff.seconds || 0)),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());

    }, 1000);

    return () => clearInterval(timer);
  }, [futureTime]);

  return (
    <>
      {
        (timeLeft.minutes > 0 || timeLeft.seconds > 0) ? 
          <>
            {String(timeLeft.minutes).padStart(2, "0")}:
            {String(timeLeft.seconds).padStart(2, "0")}
          </> :
          <span className="text-sm">Sending...</span>
      }
    </>
  );
};

MessageTimer.propTypes = {
  futureTime: Proptypes.object,
};

export default MessageTimer;